import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ObservablesService {

    connStatusSubject = new Subject<boolean>();
    loadDocsFlag = new Subject<boolean>();
    counterSigingModeFlag = new Subject<boolean>();
    currentTab = new Subject<number>()

    constructor() {
    }

    sendConnectionStatus(status: boolean) {
        this.connStatusSubject.next(status);
    }

    receiveConnectionStatus(): Observable<boolean> {
        return this.connStatusSubject.asObservable();
    }

    sendLoadDocsFlag() {
        this.loadDocsFlag.next(true);
    }

    receiveLoadDocsFlag(): Observable<boolean> {
        return this.loadDocsFlag.asObservable();
    }

    sendCounterSigingFlag(value) {
        this.counterSigingModeFlag.next(value);
    }

    receiveCounterSigingFlat(): Observable<boolean> {
        return this.counterSigingModeFlag.asObservable();
    }

    sendCurrentTab(value) {
        this.currentTab.next(value);
    }

    receiveCurrentTab(): Observable<number> {
        return this.currentTab.asObservable();
    }
}
